import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 24, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, light = false }) => (
  <div
    className={`text-[11.5px] uppercase tracking-[0.22em] font-semibold ${
      light ? "text-medis-teal" : "text-medis-teal"
    }`}
  >
    {children}
  </div>
);

export default Reveal;
